import React, { useState } from 'react'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'

import { goToRooftop } from 'actions/pageStateActions'
import { getRooftopOptions } from 'selectors/authSelectors'

import './styles.scss'

const importAll = r => r.keys().map(r)
const logos = importAll(require.context('static/images/oemLogos')).reduce(
  (ret, l) => {
    return {
      ...ret,
      [l
        .split('/')
        .slice(-1)[0]
        .split('.')[0]]: l,
    }
  },
  {},
)

const ChooseYourOwnAdventure = ({ goToRooftop, rooftops }) => {
  const [filter, setFilter] = useState('')

  if (isEmpty(rooftops)) return null

  if (rooftops && rooftops.length === 1) {
    goToRooftop(rooftops[0].short_code)
  }

  if (rooftops) {
    return (
      <>
        <input
          className="rooftop-filter"
          type="text"
          onKeyUp={e => {
            setFilter(e.target.value)
          }}
          placeholder="Type here to filter available rooftops...."
        />
        <ul className="choose-your-own-adventure">
          {rooftops
            .filter(rooftop => {
              if (filter === '') {
                return true
              }
              return (
                new RegExp(filter, 'i').test(rooftop.rooftop_name) ||
                new RegExp(filter, 'i').test(rooftop.tenant_name) ||
                new RegExp(filter, 'i').test(rooftop.short_code) ||
                new RegExp(filter, 'i').test(rooftop.theme || '')
              )
            })
            .sort((a, b) => a.rooftop_name > b.rooftop_name)
            .map((rooftop, i) => (
              <li className="rooftop-item" key={i}>
                <a href={`/${rooftop.short_code}/inventory`}>
                  <img
                    src={logos[rooftop.theme] || logos.generic}
                    alt="IllumiQuote"
                  />
                  <h2 className="is-size-4">{rooftop.rooftop_name}</h2>
                  <h3>{rooftop.tenant_name}</h3>
                </a>
              </li>
            ))}
        </ul>
      </>
    )
  }
}

function mapStateToProps(state, op) {
  return {
    goToRooftop,
    rooftops: getRooftopOptions(state),
  }
}

export default connect(
  mapStateToProps,
  {
    goToRooftop,
  },
)(ChooseYourOwnAdventure)
